import { SERVERS, GAMES, GAME_LABELS } from '../data/servers';

// Pages publiques (SEO) du site
export const PAGES = {
  home: '/',
  prices: '/prix-kamas',
  buyGuide: '/achat-kamas-maroc',
  sellGuide: '/vente-kamas-maroc',
  servers: '/serveurs-dofus',
  comparison: '/comparatif-tryandjudge',
  dofusMaroc: '/dofus-maroc',
  faq: '/faq',
  articles: '/articles',
  terms: '/conditions-utilisation',
  privacy: '/politique-confidentialite',
  buy: '/buy',
  sell: '/sell',
};

// Une page par jeu, puis une page par serveur : /kamas-dofus-3/draconiros
export const GAME_META = {
  'DOFUS 3': {
    slug: 'kamas-dofus-3',
    intro: "Dofus 3 est la version Unity de Dofus, lancée fin 2024. Ses 13 serveurs officiels se répartissent entre serveurs classiques multicomptes (Imagiro, Tal Kasha, Hell Mina, Orukam, Tylezia, Brial, Rafal, Salar), serveurs monocomptes (Draconiros, Dakal, Kourial, Mikhal) et le serveur épique Ombre.",
  },
  'DOFUS RETRO': {
    slug: 'kamas-dofus-retro',
    intro: "Dofus Rétro est la version 1.29 relancée officiellement par Ankama, avec son propre client. Trois serveurs permanents : Fallanster et Allisteria en classique, Boune en monocompte.",
  },
  'DOFUS TOUCH': {
    slug: 'kamas-dofus-touch',
    intro: "Dofus Touch est la version mobile et tablette de Dofus, avec ses propres serveurs séparés du PC : Kelerog et Tiliwan pour les joueurs francophones, Blair et Talok pour la communauté internationale.",
  },
};

export const gamePath = (game) => `/${GAME_META[game].slug}`;
export const serverPath = (server) => `${gamePath(server.game)}/${server.slug}`;
export const articlePath = (slug) => `/articles/${slug}`;
export const buyPath = (server) => `${PAGES.buy}?server=${server.slug}`;
export const sellPath = (server) => `${PAGES.sell}?server=${server.slug}`;

export const gameFromSlug = (slug) => GAMES.find(g => GAME_META[g].slug === slug);
export const gameLabel = (game) => GAME_LABELS[game];

export const serverInGame = (servers, game, slug) => servers.find(s => s.game === game && s.slug === slug);

// Liens principaux, réutilisés dans le menu et le pied de page
export const MAIN_LINKS = [
  { to: PAGES.prices, label: 'Prix des Kamas' },
  { to: PAGES.buyGuide, label: 'Achat Kamas Maroc' },
  { to: PAGES.sellGuide, label: 'Vente Kamas Maroc' },
  { to: PAGES.servers, label: 'Serveurs Dofus' },
  { to: PAGES.comparison, label: 'Comparatif TryAndJudge' },
  { to: PAGES.dofusMaroc, label: 'Dofus Maroc' },
  { to: PAGES.articles, label: 'Articles' },
  { to: PAGES.faq, label: 'FAQ' },
];

// Toutes les URLs indexables (sert de référence pour le sitemap)
export const ALL_PUBLIC_PATHS = [
  ...Object.values(PAGES),
  ...GAMES.map(gamePath),
  ...SERVERS.map(serverPath),
];
